module.exports = {
  active: 'booking',
  booking: {
    appBookable: false,
    coursesBookable: false,
    maxServices: false,
    dynamicSlotLength: false,
    slotLength: true,
    appointmentPause: true,
    currency: false,
    minLeadtime: true,
    bookAdvance: true,
    cancelLimit: false,
    acceptBooking: false,
    serviceGroupCollapsing: false,
    disablePriceColumn: false,
    disableEmployeeChooser: false,
    showBookAdditionalBtn: false,
  },
  email: {
    showCustomLogo: false,
    globalMailAddressEnabled: true,
    employeeMailAddressEnabled: false,
    sendAppointmentChangeNotificationMails: true,
  },
  reminder: {
    smsSenderName: false,
    reminderMail: true,
    reminderMailTime: true,
    reminderSMS: true,
    reminderSMSTime: true,
  },
  accounting: {
    zsrNumber: true,
    glnNumber: true,
    taxNumber: true,
    iban: true,
    bank: true,
    accountHolder: true,
    bic: true,
    paymentPeriod: true,
  },
  billingAddress: {
    companyName: true,
    firstname: true,
    lastname: true,
    city: true,
    street: true,
    number: true,
    postal: true,
    country: true,
    countryCode: true,
    telephone: true,
    fax: true,
  },
};



// WEBPACK FOOTER //
// ./src/config/coachfrog/settingsFields.js